import React from "react";
import ReactDOM from "react-dom";
import { Link, Switch, Route, Router, BrowserRouter } from "react-router-dom";

class Subheader extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
    this.targetRef = this.props.placeholderRef;
  }

  componentDidMount() {
    this.targetRef.current.appendChild(this.el);
  }

  componentWillUnmount() {
    if (this.targetRef.current) this.targetRef.current.removeChild(this.el);
  }

  render() {
    const cx = this.props.cx;
    const pageTitle = cx.breadCrumbs.length
      ? cx.breadCrumbs[cx.breadCrumbs.length - 1].title
      : "";
    cx.browserTitleSet(pageTitle);

    let crumbs =
      cx.breadCrumbs.length > 1 ? (
        <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2 font-size-sm">
          {cx.breadCrumbs.map((crumb, idx) => (
            <li key={idx} className="breadcrumb-item">
              {crumb.url ? (
                <Link to={crumb.url ? crumb.url : ""} className="text-muted">
                  {crumb.title}
                </Link>
              ) : (
                <span className="text-muted">{crumb.title}</span>
              )}
            </li>
          ))}
        </ul>
      ) : null;

    let title = pageTitle ? (
      <h5 className="text-dark font-weight-bold my-1 mr-5">{pageTitle}</h5>
    ) : null;

    let actions = (
      <div ref={cx.actionsRef} className="d-flex align-items-center"></div>
    );

    let titleArea = <div ref={cx.titleAreaRef}></div>;

    let subheader =
      crumbs || title || actions ? (
        <div className="subheader py-2 py-lg-6 subheader-solid">
          <div className="container-fluid d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
            <div className="d-flex align-items-center flex-wrap mr-1">
              {titleArea}
              <div
                ref={cx.titleAreaRivalRef}
                className="d-flex align-items-baseline flex-wrap mr-5"
              >
                {title}
                {crumbs}
              </div>
            </div>
            {actions}
          </div>
        </div>
      ) : null;

    return ReactDOM.createPortal(subheader, this.el);
  }
}
export default Subheader;
